import type { ReactNode } from "react";
import { createContext, useContext } from "react";

interface PostNavigationContextProps {
  hasNextPage?: boolean;
  params: Record<string, unknown> | string;
}

export const PostNavigationContext = createContext<PostNavigationContextProps>({
  params: {},
  hasNextPage: false,
});

PostNavigationContext.displayName = "PostNavigationContext";

interface PostNavigationProviderProps {
  children: ReactNode;
  hasNextPage?: boolean;
  params?: Record<string, unknown> | string;
}

export const PostNavigationProvider = ({
  children,
  params = {},
  hasNextPage = false,
}: PostNavigationProviderProps) => (
  <PostNavigationContext.Provider value={{ params, hasNextPage }}>
    {children}
  </PostNavigationContext.Provider>
);

export const usePostNavigationContext = () => {
  const context = useContext(PostNavigationContext);

  if (!context) {
    throw new Error(
      "usePostNavigationContext must be used within a PostNavigationProvider",
    );
  }

  return context;
};
